<template>
<!-- 听书听单分类 -->
    <div class="main">
        <div class="margin-box">
            <div class="recent-changes">
                <!-- 标题 -->
              <div class="title">
                  <div class="title-link">
                      <h3>听单分类</h3>
                  </div>
              </div>
                <!-- 听单分类内容 -->
              <div class="content">
                  <ul>
                      <li class="listen-model" v-for="(item , index) in dataList.slice(0,8)" :key="index" >
                        <router-link :to="{name:'classifyDetail', params:{id:item.id}}">
                           <img :src="item.img" alt="听单分类背景">
                           <span>{{item.name}}</span>
                        </router-link>
                      </li>
                  </ul>
              </div>

            </div>
        </div>

    </div>
</template>
<script>

// part
import generalCmpPart from '@comp/part/generalCmpPart';


const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio/category',
            dataPath : 'data',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};




export default {

    name: "listenClassify",
    extends : generalCmpPart,

    data(){
        return {
            autoLoadData : true,
            enableLottie : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,

        }
    },
     components: {
    },
    created(){

    },

    methods:{

    },
    mounted(){
    }
}
</script>
<style scoped lang="scss">

    div,ul,li,input,h1,h2,h3,h4,h5,h6 {
        margin: 0;
        padding: 0;
    }

    .main{
        padding-top: 12px;
    }
    .margin-box{
        background: #fff;

    }
    .recent-changes{
        width: 100%;
        // margin: 0 auto;
        padding: 0 16px;
        box-sizing: border-box;

        padding-bottom: 20px;
    }

    // 标题样式
    .title{
        width: 100%;
        .title-link{
            width: 100%;
            padding: 20px 0;
        }
    }

    //听单分类样式
    .content{
        ul{
            width: 100%;
            height: 84px;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: space-between;
            // align-content: space-between;

            .listen-model{
                border-radius: 4px;
                width: 23%;
                height: 38px;

                float: left;
                margin-right: 2%;
                margin-bottom: 2%;


                list-style: none;
                // margin-top: 8px;
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }
                span{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 56px;
                    height: 20px;
                    font-size: 14px;

                    font-weight: 400;
                    line-height: 14px;
                    color: #243544;

                    transform: translate(-50%,-50%);
                }

            }
        }
    }

</style>
